import { useState, useEffect, useRef } from 'react';

const services = [
  { label: 'Volet roulant', href: '/reparation-volet-roulant-lyon/' },
  { label: 'Vitrier / vitrage', href: '/vitrier-lyon/' },
  { label: 'Store / BSO', href: '/reparation-store-lyon/' },
  { label: 'Fenêtre', href: '/reparation-fenetre-lyon/' },
  { label: 'Baie vitrée', href: '/reparation-baie-vitree-lyon/' },
  { label: 'Porte & serrure', href: '/depannage-porte-serrure-lyon/' },
  { label: 'Moustiquaire', href: '/moustiquaire-lyon/' },
];

const arrondissements = [
  { label: 'Lyon 1er', href: '/depannage-menuiserie-lyon-1e/' },
  { label: 'Lyon 2e', href: '/depannage-menuiserie-lyon-2e/' },
  { label: 'Lyon 3e', href: '/depannage-menuiserie-lyon-3e/' },
  { label: 'Lyon 4e', href: '/depannage-menuiserie-lyon-4e/' },
  { label: 'Lyon 5e', href: '/depannage-menuiserie-lyon-5e/' },
  { label: 'Lyon 6e', href: '/depannage-menuiserie-lyon-6e/' },
  { label: 'Lyon 7e', href: '/depannage-menuiserie-lyon-7e/' },
  { label: 'Lyon 8e', href: '/depannage-menuiserie-lyon-8e/' },
  { label: 'Lyon 9e', href: '/depannage-menuiserie-lyon-9e/' },
  { label: 'Villeurbanne', href: '/depannage-menuiserie-villeurbanne/' },
  { label: 'Caluire-et-Cuire', href: '/depannage-menuiserie-caluire-et-cuire/' },
  { label: 'Vénissieux', href: '/depannage-menuiserie-venissieux/' },
  { label: 'Bron', href: '/depannage-menuiserie-bron/' },
  { label: 'Vaulx-en-Velin', href: '/depannage-menuiserie-vaulx-en-velin/' },
  { label: 'Saint-Priest', href: '/depannage-menuiserie-saint-priest/' },
  { label: 'Oullins-Pierre-Bénite', href: '/depannage-menuiserie-oullins-pierre-benite/' },
  { label: 'Sainte-Foy-lès-Lyon', href: '/depannage-menuiserie-sainte-foy-les-lyon/' },
  { label: 'Tassin-la-Demi-Lune', href: '/depannage-menuiserie-tassin-la-demi-lune/' },
  { label: 'Écully', href: '/depannage-menuiserie-ecully/' },
  { label: 'Francheville', href: '/depannage-menuiserie-francheville/' },
  { label: 'Rillieux-la-Pape', href: '/depannage-menuiserie-rillieux-la-pape/' },
  { label: 'Meyzieu', href: '/depannage-menuiserie-meyzieu/' },
  { label: 'Décines-Charpieu', href: '/depannage-menuiserie-decines-charpieu/' },
  { label: 'Saint-Fons', href: '/depannage-menuiserie-saint-fons/' },
];

const linkCls = 'text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [zonesOpen, setZonesOpen] = useState(false);
  const servicesRef = useRef<HTMLDivElement>(null);
  const zonesRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (servicesRef.current && !servicesRef.current.contains(e.target as Node)) setServicesOpen(false);
      if (zonesRef.current && !zonesRef.current.contains(e.target as Node)) setZonesOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <>
      <header className={`fixed top-0 left-0 right-0 z-50 bg-background-50 transition-shadow duration-300 ${scrolled ? 'shadow-[0_2px_10px_rgba(15,34,51,0.08)]' : 'border-b border-background-200'}`}>
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16 md:h-[68px] gap-4">
            <a href="/" className="flex items-center shrink-0" aria-label="DFPRO Lyon — accueil">
              <img src="/logo-dfpro.svg" alt="DFPRO Lyon — dépannage menuiserie" className="h-9 md:h-10 w-auto" width="212" height="48" />
            </a>

            <nav className="hidden lg:flex items-center gap-7">
              <a href="/" className={linkCls}>Accueil</a>

              <div className="relative" ref={servicesRef}>
                <button onClick={() => { setServicesOpen(!servicesOpen); setZonesOpen(false); }} className={`flex items-center gap-1 cursor-pointer ${linkCls}`}>
                  Services
                  <i className={`ri-arrow-down-s-line w-3.5 h-3.5 flex items-center justify-center transition-transform duration-200 ${servicesOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {servicesOpen && (
                  <div className="absolute top-full left-0 mt-2 bg-background-50 rounded-lg border border-background-200 shadow-[0_4px_16px_rgba(15,34,51,0.12)] py-2 min-w-[210px] z-50">
                    {services.map((s) => (
                      <a key={s.href} href={s.href} className="block px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors whitespace-nowrap" onClick={() => setServicesOpen(false)}>{s.label}</a>
                    ))}
                  </div>
                )}
              </div>

              <div className="relative" ref={zonesRef}>
                <button onClick={() => { setZonesOpen(!zonesOpen); setServicesOpen(false); }} className={`flex items-center gap-1 cursor-pointer ${linkCls}`}>
                  Zones d'intervention
                  <i className={`ri-arrow-down-s-line w-3.5 h-3.5 flex items-center justify-center transition-transform duration-200 ${zonesOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {zonesOpen && (
                  <div className="absolute top-full right-0 mt-2 bg-background-50 rounded-lg border border-background-200 shadow-[0_4px_16px_rgba(15,34,51,0.12)] py-2 z-50 grid grid-cols-2 gap-x-2 w-[360px]">
                    {arrondissements.map((arr) => (
                      <a key={arr.href} href={arr.href} className="block px-4 py-1.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors whitespace-nowrap" onClick={() => setZonesOpen(false)}>{arr.label}</a>
                    ))}
                  </div>
                )}
              </div>

              <a href="/blog/" className={linkCls}>Blog</a>
              <a href="/contact/" className={linkCls}>Contact</a>
              <a href="tel:+33980803684" className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-sm px-4 py-2.5 rounded-md transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-phone-fill text-base w-4 h-4 flex items-center justify-center"></i>
                09 80 80 36 84
              </a>
            </nav>

            <div className="flex lg:hidden items-center gap-3">
              <a href="tel:+33980803684" className="inline-flex items-center justify-center bg-accent-500 hover:bg-accent-600 text-background-50 w-10 h-10 rounded-full transition-colors cursor-pointer" aria-label="Appeler le 09 80 80 36 84">
                <i className="ri-phone-fill text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="inline-flex items-center justify-center w-10 h-10 rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer" aria-label="Menu">
                <i className={`text-xl w-5 h-5 flex items-center justify-center ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </button>
            </div>
          </div>

          {mobileMenuOpen && (
            <div className="lg:hidden bg-background-50 border-t border-background-200 py-4 px-2 max-h-[75vh] overflow-y-auto">
              <nav className="flex flex-col gap-1">
                <a href="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 px-3 rounded-md" onClick={() => setMobileMenuOpen(false)}>Accueil</a>
                <span className="text-xs font-semibold text-secondary-400 uppercase tracking-wider px-3 pt-3 pb-1">Services</span>
                {services.map((s) => (
                  <a key={s.href} href={s.href} className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 px-3 rounded-md" onClick={() => setMobileMenuOpen(false)}>{s.label}</a>
                ))}
                <span className="text-xs font-semibold text-secondary-400 uppercase tracking-wider px-3 pt-3 pb-1">Zones d'intervention</span>
                <div className="grid grid-cols-3 gap-0.5 px-1">
                  {arrondissements.map((arr) => (
                    <a key={arr.href} href={arr.href} className="text-xs font-medium text-foreground-700 hover:text-primary-500 py-1.5 px-1.5 rounded-md text-center" onClick={() => setMobileMenuOpen(false)}>{arr.label}</a>
                  ))}
                </div>
                <a href="/blog/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 px-3 rounded-md mt-2" onClick={() => setMobileMenuOpen(false)}>Blog</a>
                <a href="/contact/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 px-3 rounded-md" onClick={() => setMobileMenuOpen(false)}>Contact</a>
                <a href="tel:+33980803684" className="inline-flex items-center justify-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-sm py-2.5 rounded-md mt-2" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-phone-fill text-base w-4 h-4 flex items-center justify-center"></i>09 80 80 36 84
                </a>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* spacer pour compenser le header fixe */}
      <div className="h-16 md:h-[68px]"></div>

      {/* CTA flottant mobile */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-background-50 border-t border-background-200 px-3 py-2.5">
        <div className="flex items-center gap-2">
          <a href="tel:+33980803684" className="flex-1 inline-flex items-center justify-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-sm py-3 rounded-md cursor-pointer shadow-[0_2px_8px_rgba(242,140,40,0.35)]">
            <i className="ri-phone-fill w-4 h-4 flex items-center justify-center"></i>Appeler — 09 80 80 36 84
          </a>
          <a href="/contact/" className="flex-1 inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm py-3 rounded-md cursor-pointer">
            <i className="ri-file-list-3-line w-4 h-4 flex items-center justify-center"></i>Devis gratuit
          </a>
        </div>
      </div>
    </>
  );
}
